import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="scroll"
export default class extends Controller {
  static targets = ["top"];
  static values = { behavior: { type: String, default: "auto" } };

  connect() {
    // 子コントローラのスクロール完了後、次フレームで最上部へ移動
    requestAnimationFrame(() => this.scrollToTop());
  }

  scrollToTop() {
    if (this.hasTopTarget) {
      this.topTarget.scrollIntoView({ behavior: this.behaviorValue, block: "start" });
    } else {
      window.scrollTo({ top: 0, behavior: this.behaviorValue });
    }
  }
}
